module.exports = __webpack_public_path__ + "static/media/01-homepage.c685c4da.png";